import React from 'react';
import { motion } from 'framer-motion';
import { Crown, Calendar, Phone } from 'lucide-react';
export function Hero() {
  return <section className="flex flex-col w-full" data-id="element-109">
      {/* Banner Image */}
      <div className="w-full relative" data-id="element-110">
        <img src="https://cdn.magicpatterns.com/uploads/h14bwFY9HaVHeYKdQru2AU/banner_original.png" alt="Prince Barber Studio Team" className="w-full h-auto block" data-id="element-111" />
        {/* Subtle gradient at the bottom to blend into the dark background */}
        <div className="absolute inset-x-0 bottom-0 h-24 md:h-40 bg-gradient-to-t from-dark to-transparent" data-id="element-112"></div>
      </div>

      {/* Text Content */}
      <div className="container mx-auto px-6 py-16 text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-114">
          <div className="mb-6 p-4 rounded-full bg-dark-surface border border-gold/20 shadow-[0_0_15px_rgba(201,168,76,0.1)]" data-id="element-115">
            <Crown className="text-gold w-12 h-12" data-id="element-116" />
          </div>

          <h2 className="text-gold font-sans tracking-[0.2em] text-sm md:text-base uppercase mb-4" data-id="element-117">
            Prince Barber Studio
          </h2>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight" data-id="element-118">
            QUE TU ESTILO <br data-id="element-119" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light" data-id="element-120">
              HABLE POR TI
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto font-light" data-id="element-121">
            Viví la experiencia de sentirte un Prince.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto" data-id="element-122">
            <a href="https://book.weibook.co/princebarberstudio" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-dark font-semibold px-8 py-4 rounded-sm transition-all duration-300 transform hover:scale-105" data-id="element-123">
              <Calendar size={20} data-id="element-124" />
              AGENDARTE AHORA
            </a>
            <a href="#cursos" className="w-full sm:w-auto flex items-center justify-center gap-2 border border-gold text-gold hover:bg-gold/10 font-semibold px-8 py-4 rounded-sm transition-all duration-300" data-id="element-125">
              VER CURSOS
            </a>
          </div>

          <div className="mt-12 flex items-center gap-2 text-gray-400 hover:text-gold transition-colors" data-id="element-126">
            <Phone size={18} data-id="element-127" />
            <a href="tel:091414192" className="font-sans tracking-wider" data-id="element-128">
              091 414 192
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}